// YDG WRLD JEWELS — SHOP (catalog grid) page
// Vanilla JS, no frameworks. Data source: YDG_PRODUCTS (js/products.js).

(function () {
  'use strict';

  const CART_KEY = 'ydg_cart';

  // ================================================================
  //  FLATTEN + DERIVE FILTER FACETS FROM REAL PRODUCT DATA
  // ================================================================
  const ALL_PRODUCTS = [];
  if (typeof YDG_PRODUCTS !== 'undefined') {
    for (const cat of Object.keys(YDG_PRODUCTS)) {
      for (const p of YDG_PRODUCTS[cat]) {
        ALL_PRODUCTS.push(Object.assign({ category: cat }, p));
      }
    }
  }

  const COLOR_HEX = {
    blue: '#5fb7d4', red: '#c8452e', green: '#4a8c62', pink: '#e58fb1',
    yellow: '#e8c34a', black: '#1a1a1a', clear: '#e9e6df'
  };

  function detectColor(title) {
    const t = title.toLowerCase();
    for (const c of Object.keys(COLOR_HEX)) { if (t.includes(c)) return c; }
    return null;
  }
  function detectMetal(title) {
    const t = title.toLowerCase();
    if (t.includes('gold')) return 'gold';
    if (t.includes('silver')) return 'silver';
    return null;
  }

  ALL_PRODUCTS.forEach(function (p) {
    p.color = detectColor(p.title);
    p.metal = detectMetal(p.title);
    p.priceNum = parseFloat(p.price) || 0;
    // Real Shopify inventory flag (from live product data) — this is
    // now the source of truth for sold-out state, not price === 0.
    p.soldOut = (p.available === false);
    // WRLD CROSS pendants are necklaces at heart — merge them into the
    // "necklaces" category for browsing/filtering. They're also the
    // newest drop.
    p.isNew = (p.category === 'cross');
    if (p.category === 'cross') p.category = 'necklaces';
  });

  // "New Arrivals" mirrors the live store's /collections/all — the full
  // catalog, newest pieces (WRLD CROSS) surfaced first.
  ALL_PRODUCTS.sort(function (a, b) { return (b.isNew ? 1 : 0) - (a.isNew ? 1 : 0); });

  const CATEGORY_LABELS = { necklaces: 'Necklaces', bracelets: 'Bracelets' };
  const PRICE_BUCKETS = [
    { key: 'under-50', label: 'Under $50', test: function (n) { return n > 0 && n < 50; } },
    { key: '50-100', label: '$50 to $100', test: function (n) { return n >= 50 && n <= 100; } },
    { key: 'over-100', label: 'Over $100', test: function (n) { return n > 100; } }
  ];

  function uniq(arr) { return Array.from(new Set(arr.filter(Boolean))); }

  const facets = {
    category: uniq(ALL_PRODUCTS.map(function (p) { return p.category; })),
    color: uniq(ALL_PRODUCTS.map(function (p) { return p.color; })),
    metal: uniq(ALL_PRODUCTS.map(function (p) { return p.metal; }))
  };

  // ================================================================
  //  STATE
  // ================================================================
  const state = { category: null, color: null, metal: null, price: null, isNew: false };

  function applyFilters() {
    return ALL_PRODUCTS.filter(function (p) {
      if (state.category && p.category !== state.category) return false;
      if (state.color && p.color !== state.color) return false;
      if (state.metal && p.metal !== state.metal) return false;
      if (state.price) {
        const bucket = PRICE_BUCKETS.find(function (b) { return b.key === state.price; });
        if (bucket && !bucket.test(p.priceNum)) return false;
      }
      return true;
    });
  }

  function escHtml(s) {
    return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function fmtPrice(n, soldOut) {
    if (soldOut) return 'SOLD OUT';
    return '$' + (n || 0).toFixed(2);
  }

  // ================================================================
  //  RENDER FILTER MENUS
  // ================================================================
  function renderFilterMenus() {
    const catMenu = document.querySelector('[data-menu="category"]');
    if (catMenu) {
      catMenu.innerHTML = facets.category.map(function (c) {
        return '<button class="shop-filter-opt' + (state.category === c ? ' is-active' : '') + '" data-set="category" data-val="' + c + '">' +
          escHtml(CATEGORY_LABELS[c] || c) + '</button>';
      }).join('');
    }

    const colorMenu = document.querySelector('[data-menu="color"]');
    if (colorMenu) {
      colorMenu.innerHTML = facets.color.map(function (c) {
        return '<button class="shop-filter-opt' + (state.color === c ? ' is-active' : '') + '" data-set="color" data-val="' + c + '">' +
          '<span class="shop-filter-swatch" style="background:' + (COLOR_HEX[c] || '#ccc') + '"></span>' + escHtml(c) + '</button>';
      }).join('');
    }

    const metalMenu = document.querySelector('[data-menu="metal"]');
    if (metalMenu) {
      metalMenu.innerHTML = facets.metal.map(function (m) {
        return '<button class="shop-filter-opt' + (state.metal === m ? ' is-active' : '') + '" data-set="metal" data-val="' + m + '">' + escHtml(m) + '</button>';
      }).join('');
    }

    const priceMenu = document.querySelector('[data-menu="price"]');
    if (priceMenu) {
      priceMenu.innerHTML = PRICE_BUCKETS.map(function (b) {
        return '<button class="shop-filter-opt' + (state.price === b.key ? ' is-active' : '') + '" data-set="price" data-val="' + b.key + '">' + escHtml(b.label) + '</button>';
      }).join('');
    }

    document.querySelectorAll('.shop-filter-opt').forEach(function (btn) {
      btn.addEventListener('click', function () {
        const key = btn.dataset.set;
        const val = btn.dataset.val;
        state[key] = (state[key] === val) ? null : val;
        closeAllMenus();
        renderFilterMenus();
        renderGrid();
        updateFilterButtonStates();
      });
    });
  }

  function updateFilterButtonStates() {
    document.getElementById('filterCategory').classList.toggle('has-active', !!state.category);
    document.getElementById('filterColor').classList.toggle('has-active', !!state.color);
    document.getElementById('filterMetal').classList.toggle('has-active', !!state.metal);
    document.getElementById('filterPrice').classList.toggle('has-active', !!state.price);
    const anyActive = state.category || state.color || state.metal || state.price;
    const clearBtn = document.getElementById('shopFilterClear');
    if (clearBtn) clearBtn.hidden = !anyActive;
  }

  function closeAllMenus() {
    document.querySelectorAll('.shop-filter').forEach(function (f) { f.classList.remove('is-open'); });
  }

  // ================================================================
  //  RENDER PRODUCT GRID
  // ================================================================
  function renderGrid() {
    const grid = document.getElementById('shopGrid');
    const countEl = document.getElementById('shopCount');
    if (!grid) return;

    const results = applyFilters();

    if (countEl) {
      countEl.textContent = results.length + (results.length === 1 ? ' PIECE' : ' PIECES');
    }

    if (results.length === 0) {
      grid.innerHTML = '<p class="shop-empty">No pieces match those filters. Try clearing one.</p>';
      return;
    }

    grid.innerHTML = results.map(function (p) {
      const img = p.images && p.images[0] ? p.images[0] : '';
      const soldOut = p.soldOut;
      return '<a class="shop-card" href="/pages/product-1?handle=' + encodeURIComponent(p.handle) + '" role="listitem">' +
        '<div class="shop-card-img-wrap">' +
          (img ? '<img class="shop-card-img" src="' + escHtml(img) + '" alt="' + escHtml(p.title) + '" loading="lazy">' : '') +
          (soldOut ? '<span class="shop-card-badge is-soldout">SOLD OUT</span>' : '') +
        '</div>' +
        '<div class="shop-card-meta">' +
          '<span class="shop-card-title">' + escHtml(p.title) + '</span>' +
          '<span class="shop-card-price">' + fmtPrice(p.priceNum, soldOut) + '</span>' +
        '</div>' +
      '</a>';
    }).join('');
  }

  // ================================================================
  //  CART (real Shopify Storefront API cart, via window.YDGCart)
  // ================================================================
  function shopifyCartLines() {
    const cart = window.YDGCart && window.YDGCart.getCached();
    if (!cart || !cart.lines || !cart.lines.edges) return [];
    return cart.lines.edges.map(function (e) { return e.node; });
  }
  function cartCount() {
    const cart = window.YDGCart && window.YDGCart.getCached();
    return cart ? (cart.totalQuantity || 0) : 0;
  }
  function cartSubtotal() {
    const cart = window.YDGCart && window.YDGCart.getCached();
    if (!cart || !cart.cost) return 0;
    return parseFloat(cart.cost.subtotalAmount.amount) || 0;
  }
  function updateCartBadge() {
    const count = cartCount();
    const el = document.getElementById('pdpCartCount');
    if (el) { el.textContent = count; el.classList.toggle('is-zero', count === 0); }
  }
  function renderCartItems() {
    const container = document.getElementById('pdpCartItems');
    const subtotalEl = document.getElementById('pdpCartSubtotal');
    if (!container) return;
    const lines = shopifyCartLines();
    if (lines.length === 0) {
      container.innerHTML = '<p class="pdp-cart-empty">YOUR BAG IS EMPTY.</p>';
    } else {
      container.innerHTML = lines.map(function (line) {
        const m = line.merchandise;
        const title = (m.product && m.product.title) || m.title || 'Item';
        const img = (m.image && m.image.url) || '';
        const lineTotal = parseFloat(line.cost.totalAmount.amount).toFixed(2);
        return '<div class="pdp-cart-item" data-line-id="' + escHtml(line.id) + '">' +
          '<img class="pdp-cart-item-img" src="' + escHtml(img) + '" alt="' + escHtml(title) + '" loading="lazy">' +
          '<div>' +
            '<p class="pdp-cart-item-title">' + escHtml(title) + '</p>' +
            '<p class="pdp-cart-item-price">$' + lineTotal + '</p>' +
            '<div class="pdp-cart-item-qty">' +
              '<button class="pdp-cart-item-qty-btn" data-action="dec" data-line-id="' + escHtml(line.id) + '" data-qty="' + line.quantity + '">&#8722;</button>' +
              '<span class="pdp-cart-item-qty-val">' + line.quantity + '</span>' +
              '<button class="pdp-cart-item-qty-btn" data-action="inc" data-line-id="' + escHtml(line.id) + '" data-qty="' + line.quantity + '">+</button>' +
            '</div>' +
          '</div>' +
          '<button class="pdp-cart-item-remove" data-line-id="' + escHtml(line.id) + '">&#215;</button>' +
        '</div>';
      }).join('');
      container.querySelectorAll('.pdp-cart-item-qty-btn').forEach(function (btn) {
        btn.addEventListener('click', function () {
          const lineId = btn.dataset.lineId;
          const qty = parseInt(btn.dataset.qty, 10) || 1;
          const delta = btn.dataset.action === 'inc' ? 1 : -1;
          const newQty = Math.max(1, qty + delta);
          if (window.YDGCart) {
            window.YDGCart.updateLine(lineId, newQty).then(function () {
              updateCartBadge();
              renderCartItems();
            });
          }
        });
      });
      container.querySelectorAll('.pdp-cart-item-remove').forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (window.YDGCart) {
            window.YDGCart.removeLine(btn.dataset.lineId).then(function () {
              updateCartBadge();
              renderCartItems();
            });
          }
        });
      });
    }
    if (subtotalEl) subtotalEl.textContent = '$' + cartSubtotal().toFixed(2);

    const checkoutBtn = document.getElementById('pdpCartCheckout');
    if (checkoutBtn) {
      const url = window.YDGCart && window.YDGCart.getCheckoutUrl();
      if (url) {
        checkoutBtn.href = url;
        checkoutBtn.removeAttribute('target');
        checkoutBtn.classList.remove('is-disabled');
      } else {
        checkoutBtn.href = '#';
        checkoutBtn.classList.add('is-disabled');
      }
    }
  }

  function openCartDrawer() {
    const overlay = document.getElementById('pdpCartOverlay');
    const drawer = document.getElementById('pdpCartDrawer');
    if (!overlay || !drawer) return;
    renderCartItems();
    overlay.classList.add('is-open');
    drawer.classList.add('is-open');
    overlay.setAttribute('aria-hidden', 'false');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function closeCartDrawer() {
    const overlay = document.getElementById('pdpCartOverlay');
    const drawer = document.getElementById('pdpCartDrawer');
    if (!overlay || !drawer) return;
    overlay.setAttribute('aria-hidden', 'true');
    drawer.setAttribute('aria-hidden', 'true');
    overlay.classList.remove('is-open');
    drawer.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  // ================================================================
  //  NAV
  // ================================================================
  function initNav() {
    const nav = document.getElementById('pdpNav');
    const menuBtn = document.getElementById('pdpMenuBtn');
    const menu = document.getElementById('pdpNavMenu');
    const cartBtn = document.getElementById('pdpCartBtn');

    if (nav) {
      window.addEventListener('scroll', function () {
        nav.classList.toggle('is-scrolled', window.scrollY > 20);
      }, { passive: true });
    }
    if (menuBtn && menu) {
      menuBtn.addEventListener('click', function () {
        const open = menu.classList.toggle('is-open');
        menuBtn.classList.toggle('is-open', open);
      });
    }
    if (cartBtn) {
      cartBtn.addEventListener('click', function (e) { e.preventDefault(); openCartDrawer(); });
    }
    const cartClose = document.getElementById('pdpCartClose');
    const cartOverlay = document.getElementById('pdpCartOverlay');
    if (cartClose) cartClose.addEventListener('click', closeCartDrawer);
    if (cartOverlay) cartOverlay.addEventListener('click', function (e) { if (e.target === cartOverlay) closeCartDrawer(); });

    if (window.YDGCart) {
      window.YDGCart.onChange(function () { updateCartBadge(); });
    }
    updateCartBadge();
  }

  // ================================================================
  //  INIT
  // ================================================================
  function init() {
    document.documentElement.classList.add('pdp-root');
    initNav();

    // Pre-select category from ?cat= query param (nav menu links use this)
    const params = new URLSearchParams(window.location.search);
    const cat = params.get('cat');
    if (cat && facets.category.includes(cat)) state.category = cat;
    // ?new=1 -> New Arrivals view (the WRLD CROSS drop)
    if (params.get('new') === '1') state.isNew = true;

    renderFilterMenus();
    updateFilterButtonStates();
    renderGrid();

    // Filter dropdown toggles
    document.querySelectorAll('.shop-filter-btn').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        const parent = btn.closest('.shop-filter');
        const wasOpen = parent.classList.contains('is-open');
        closeAllMenus();
        if (!wasOpen) parent.classList.add('is-open');
      });
    });
    document.addEventListener('click', function () { closeAllMenus(); });

    const clearBtn = document.getElementById('shopFilterClear');
    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        state.category = null; state.color = null; state.metal = null; state.price = null; state.isNew = false;
        renderFilterMenus();
        updateFilterButtonStates();
        renderGrid();
        updateSlab();
      });
    }

    updateSlab();
  }

  function updateSlab() {
    const slab = document.getElementById('shopSlab');
    if (slab) slab.textContent = state.isNew ? 'NEW ARRIVALS' : 'CATALOG';
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
